import { useLazyQuery, useQuery } from "@apollo/client/react";
import type { ResultOf, VariablesOf } from "@graphql-typed-document-node/core";
import { AdvertsDocument } from "./queries/adverts.graphql";
import { DeliverableDocument } from "./queries/deliverable.graphql";
import { LanguagesDocument } from "./queries/languages.graphql";
import { ProjectVariantsDocument } from "./queries/project-variants.graphql";
import { ReviewDeliverableDocument } from "./queries/review-deliverable.graphql";
import { SpecificationDocument } from "./queries/specification.graphql";
import { SpecificationRevisionCapabilityDocument } from "./queries/specification-revision-capability.graphql";
import {
  type SpecificationVersionsQuery,
  type SpecificationVersionsQueryVariables,
} from "./generated/graphql";
import { SpecificationVersionsDocument } from "./queries/specification-versions.graphql";

export const useAdvertsQuery = (
  options: useQuery.Options<
    ResultOf<typeof AdvertsDocument>,
    VariablesOf<typeof AdvertsDocument>
  >,
) => useQuery(AdvertsDocument, options);

export const useDeliverableQuery = (
  options: useQuery.Options<
    ResultOf<typeof DeliverableDocument>,
    VariablesOf<typeof DeliverableDocument>
  >,
) => useQuery(DeliverableDocument, options);

export const useLanguagesQuery = (
  options?: useQuery.Options<
    ResultOf<typeof LanguagesDocument>,
    VariablesOf<typeof LanguagesDocument>
  >,
) => useQuery(LanguagesDocument, options);

export const useProjectVariantsQuery = (
  options: useQuery.Options<
    ResultOf<typeof ProjectVariantsDocument>,
    VariablesOf<typeof ProjectVariantsDocument>
  >,
) => useQuery(ProjectVariantsDocument, options);

export const useReviewDeliverableQuery = (
  options: useQuery.Options<
    ResultOf<typeof ReviewDeliverableDocument>,
    VariablesOf<typeof ReviewDeliverableDocument>
  >,
) => useQuery(ReviewDeliverableDocument, options);

export const useReviewDeliverableLazyQuery = (
  options?: useLazyQuery.Options<
    ResultOf<typeof ReviewDeliverableDocument>,
    VariablesOf<typeof ReviewDeliverableDocument>
  >,
) => useLazyQuery(ReviewDeliverableDocument, options);

export const useSpecificationQuery = (
  options: useQuery.Options<
    ResultOf<typeof SpecificationDocument>,
    VariablesOf<typeof SpecificationDocument>
  >,
) => useQuery(SpecificationDocument, options);

export const useSpecificationRevisionCapabilityQuery = (
  options: useQuery.Options<
    ResultOf<typeof SpecificationRevisionCapabilityDocument>,
    VariablesOf<typeof SpecificationRevisionCapabilityDocument>
  >,
) => useQuery(SpecificationRevisionCapabilityDocument, options);

export const useSpecificationVersionsQuery = (
  options: useQuery.Options<
    SpecificationVersionsQuery,
    SpecificationVersionsQueryVariables
  >,
) => useQuery(SpecificationVersionsDocument, options);
